import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./utils/translations/en.json";
import ar from "./utils/translations/ar.json";
import { getStrings } from "./modules/home";

// const response = await getStrings(
//   localStorage.getItem("language") == "AR" ? "ar" : "en"
// );
// console.log("stringResponse", response.data);

const resources = {
  en: {
    translation: en,
  },
  ar: {
    translation: ar,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem("language")== "AR" ? "ar":"en",
  fallbackLng: "en",

  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
